import { render, staticRenderFns } from "./listCom.vue?vue&type=template&id=07bb0835&scoped=true&"
import script from "./listCom.vue?vue&type=script&lang=js&"
export * from "./listCom.vue?vue&type=script&lang=js&"
import style0 from "./listCom.vue?vue&type=style&index=0&id=07bb0835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb0835",
  null
  
)

export default component.exports